import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { FindTrackType } from '../../../types/filter.type'

@Component({
  selector: 'bmcore-search-beat-input',
  templateUrl: './bmcore-search-beat-input.component.html',
  styleUrls: ['./bmcore-search-beat-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSearchBeatInputComponent implements OnInit {
  @Input() searchTrack: string
  @Output() changeBeatValueEvent = new EventEmitter<FindTrackType>()

  lg: LgType

  constructor(private i18nService: I18nService) {
    this.lg = this.i18nService.getLanguageForPage()
  }

  ngOnInit(): void {}

  changeBeatValue(searchData: FindTrackType) {
    this.changeBeatValueEvent.emit({ search: searchData.search, searchType: searchData.searchType })
  }
}
